import { finalizeFanSuperMessagePurchaseByCreditCard } from '@/mocks/resolvers/mutations/finalize-fan-super-message-purchase-by-credit-card';
import { postArtistPerformanceContent } from '@/mocks/resolvers/mutations/post-artist-performance-content';
import { postFanContent } from '@/mocks/resolvers/mutations/post-fan-content';
import { postFanSuperMessageByRegisteredCreditCard } from '@/mocks/resolvers/mutations/post-fan-super-message-by-registered-credit-card';
import { getPaymentRelatedSuperMessage } from '@/mocks/resolvers/queries/get-payment-related-super-message';
import { getPerformanceChannelContents } from '@/mocks/resolvers/queries/get-performance-channel-contents';
import { getPerformanceChannelPostDetail } from '@/mocks/resolvers/queries/get-performance-channel-post-detail';

export const mockResolvers = [
  // MEMO: このエラーモックは、errorPolicy: 'ignore' を指定した Query の挙動確認用です。
  //       常時有効にする必要はないため、検証時のみ handlers に追加してください。
  // getArtistError,
  // getPerformanceChannelError,
  // getMeCreditCardsError,
  // getPerformanceChannelPostDetailError,
  // getMeError,
  // getMeProfileError,
  // getPerformanceChannelPinnedPostContentsError,
  // getRelatedPerformanceChannelsError,
  // getMyArtistOfficialsByChannelIdError,
  getPerformanceChannelContents,
  postFanContent,
  getPerformanceChannelPostDetail,
  postArtistPerformanceContent,
  getPaymentRelatedSuperMessage,
  finalizeFanSuperMessagePurchaseByCreditCard,
  postFanSuperMessageByRegisteredCreditCard,
];
